import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

import {firstLetterUpperCased} from '../../lib/tools'

const AccountTooltip = ({user, open, handleClick}) => (
  <Tooltip title='Account settings'>
    <IconButton
      color='secondary'
      onClick={handleClick}
      size='small'
      sx={{ml: 2}}
      aria-controls={open ? 'account-menu' : undefined}
      aria-haspopup='true'
      aria-expanded={open ? 'true' : undefined}
    >
      {
        user?.firstName && (
          <Avatar sx={{bgcolor: 'text.primary', width: 32, height: 32}}>{firstLetterUpperCased(user.firstName)}</Avatar>
        )
      }
    </IconButton>
  </Tooltip>
)

export default AccountTooltip
